import React from "react";
import { Report316 } from "../../../containers";

const Report316Container = (props) => {
  return <Report316 {...props} />;
};

export default Report316Container;
